import { render, staticRenderFns } from "./BotAgentCreateModal.vue?vue&type=template&id=07d5bf4d"
import script from "./BotAgentCreateModal.vue?vue&type=script&lang=ts"
export * from "./BotAgentCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports